export const bestConfigurationsQuery = `
query BestConfigurations($criteria: ConfigurationCriteria, $bestOnePer: [ConfigurationProperty!], $bestRule: BestRule) {
  configurations(criteria: $criteria, bestOnePer: $bestOnePer, bestRule: $bestRule) {
    __typename
    id
    product {
      id
    }
    modality {
      id
    }
    customerGroup {
      id
    }
    term {
      id
    }
    price {
      amount
      currency
    }
    pricePerYear {
      amount
      currency
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/products-api/queries/best-configurations.js